import { useCallback } from "react"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { I18N_NAMESPACE, useCampaignProject, useCampaigns } from "@l2r-front/l2r-shared-campaign"

import { useCampaignCreate } from "../../hooks/mutations/useCampaignCreate"

import { CampaignForm } from "../CampaignForm"

const MAX_CAMPAIGNS_FOR_NAME_VALIDATION = 1000

export interface CampaignAddFormProps {
    onClose: (_checkModifications?: boolean) => void
    onChange: (hasChanges: boolean) => void
    onSubmitting: (_submitting: boolean) => void
}

export const CampaignAddForm = (props: CampaignAddFormProps) => {

    const {
        onClose,
        onChange,
        onSubmitting,
    } = props

    const { t } = useTranslation(I18N_NAMESPACE)

    const campaignMutation = useCampaignCreate({}, {
        errorSnackbarMessage: t(I18N_NAMESPACE, "forms.campaignAddForm.snackbar.error"),
        successSnackbarMessage: t(I18N_NAMESPACE, "forms.campaignAddForm.snackbar.success"),
        onSuccess: () => {
            onSubmitting(false)
            onClose(false)
        },
        onError: () => {
            onSubmitting(false)
        },
    })
    const { data: project } = useCampaignProject()
    const { data: campaignsData, isLoading: isLoadingCampaigns } = useCampaigns({ limit: MAX_CAMPAIGNS_FOR_NAME_VALIDATION })

    const onSubmit = useCallback((formValues) => {
        const params = {
            ...formValues,
            cost: 0,
            project: project.uuid
        }
        campaignMutation.mutate(params)
        onSubmitting(true)
    }, [campaignMutation, project, onSubmitting])

    if (isLoadingCampaigns) {
        return null
    }

    return <CampaignForm
        campaigns={campaignsData?.results || []}
        isSubmitting={campaignMutation.isPending}
        onSubmit={onSubmit}
        onChange={onChange}
        onCancel={() => onClose()}
    />
}

